import { Flow } from '@/components/Flow';
import { Step } from '@/components/Step';

export const LegalEntityRelationFlow = () => {
  return (
    <Flow>
      <Flow.StepList>
        <Step name='legal-entity-relation' />
      </Flow.StepList>
    </Flow>
  );
};
